var map = {
	"../pages/about-us/about-us.module": [
		363,
		7
	],
	"../pages/add-address/add-address.module": [
		364,
		23
	],
	"../pages/address-list/address-list.module": [
		365,
		22
	],
	"../pages/booking-history/booking-history.module": [
		366,
		25
	],
	"../pages/cart/cart.module": [
		367,
		21
	],
	"../pages/category/category.module": [
		368,
		20
	],
	"../pages/chat/chat.module": [
		369,
		0
	],
	"../pages/checkout/checkout.module": [
		370,
		6
	],
	"../pages/contact/contact.module": [
		371,
		9
	],
	"../pages/favourite/favourite.module": [
		372,
		19
	],
	"../pages/home/home.module": [
		373,
		18
	],
	"../pages/location/location.module": [
		374,
		2
	],
	"../pages/login/login.module": [
		375,
		1
	],
	"../pages/news-detail/news-detail.module": [
		376,
		17
	],
	"../pages/news/news.module": [
		377,
		16
	],
	"../pages/offer/offer.module": [
		378,
		15
	],
	"../pages/order-details/order-details.module": [
		379,
		5
	],
	"../pages/order-status/order-status.module": [
		380,
		14
	],
	"../pages/orders/orders.module": [
		381,
		13
	],
	"../pages/product-details/product-details.module": [
		382,
		12
	],
	"../pages/product-list/product-list.module": [
		383,
		4
	],
	"../pages/rating/rating.module": [
		384,
		8
	],
	"../pages/registration/registration.module": [
		385,
		3
	],
	"../pages/settings/settings.module": [
		386,
		11
	],
	"../pages/table-booking/table-booking.module": [
		387,
		24
	],
	"../pages/thankyou/thankyou.module": [
		388,
		10
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 173;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src lazy
// module id = 173
// module chunks = 26